<template>
	<div>
		<v-autocomplete
			:class="dense ? 'grv-input-dense' : 'grv-input'"
			class="chiped-input"
			:menu-props="{contentClass: 'grv-menu'}"
			:rules="rules"
			@update:error="errored = $event"
			:value="value"
			clearable
			:name="param.name"
			:items="items"
			:loading="loading"
			item-text="name"
			item-value="id"
			:search-input.sync="search"
			:readonly="readonly"
			auto-select-first
			:dense="dense"
			no-filter
			hide-no-data
			chips
			:small-chips="dense"
			:deletable-chips="!readonly"
			:placeholder="items.length ? 'Selectionner un patron' : 'Rechercher une plateforme'"
			@change="$emit('update:value', $event)">

			<template v-slot:label>
				<Label :param="param"></Label>
			</template>

		</v-autocomplete>

		<Hint :param="param" :errored="errored"></Hint>
	</div>
</template>

<script>
import { debounce } from 'debounce'
import Label from '@/components/fields/label.vue'
import Hint from '@/components/fields/hint.vue'
export default {
	props: [
		'param',
		'value',
		'readonly',
		'dense'
	],
	components: {
		Label,
		Hint
	},
	data () {
		return {
			rules: [],
			errored: false,
			items: [],
			ids: [],
			search: null,
			loading: false,
			has_choices: false,
			validation_infos: {},
			errors: []
		}
	},
	watch: {
		search (val) {
			if (val && this.ids.indexOf(val) === -1) {
				this.platformSearch(val)
			}
		},
		value (val) {
			if (val && this.ids.indexOf(val) === -1) {
				this.getPlatform(val)
			}
		}
	},
	methods: {
		platformSearch: debounce(function (search) {
			if (!search) return
			if (search.length < 2) return
			if (this.loading) return
			this.getPlatforms(search)
		}, 100),
		getPlatforms (search) {
			if (this.has_choices) return
			this.loading = true
			this.$EsMaestro.confplatform_search(search)
				.then(platforms => {
					this.items = platforms
					this.ids = platforms.map(platform => platform.id)
					if (platforms.length === 1) {
						let value = platforms[0].id
						if (search === value) {
							this.$emit('update:value', value)
						}
					}
				})
				.catch(err => { console.log(err) })
				.finally(() => { this.loading = false })
		},
		getPlatform (id) {
			if (this.has_choices) return
			this.loading = true
			this.$EsMaestro.confplatform_read(id)
				.then(platforms => {
					this.items = platforms
					this.ids = platforms.map(platform => platform.id)
				})
				.catch(err => { console.log(err) })
				.finally(() => { this.loading = false })
		},
		requiredCheck (value) {
			if (value === '') return 'Requis'
			if (value === null) return 'Requis'
			if (value === undefined) return 'Requis'
			return true
		}
	},
	mounted () {
		if (!this.param) return
		if (this.param.required || this.param.required === undefined) {
			this.rules.push(this.requiredCheck)
		}
		if (this.param.choices.length > 0) {
			this.items = this.param.choices
			this.has_choices = true
		}
		if (this.value) this.getPlatform(this.value)
	}
}
</script>



// WEBPACK FOOTER //
// src/components/fields/confplatformid.vue